module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iter-step.js
// module id = 237
// module chunks = 1